import { createAction, Reducer } from '@reduxjs/toolkit';

export const resetStateAction = /* @__PURE__ */ createAction('@@modules/testing/resetState');
export const setSliceStateAction = /* @__PURE__ */ createAction<{ name: string; state: unknown }>(
    '@@modules/testing/setSliceState'
);
export const resetSliceStateAction = /* @__PURE__ */ createAction<{ name: string }>(
    '@@modules/testing/resetSliceState'
);

/**
 * Патч для редьюсера всего стора.
 * Добавляет в стор внутренние экшены для тестирования.
 */
export function patchStoreReducer(reducer: Reducer): Reducer {
    return (state, action) => {
        if (setSliceStateAction.match(action)) {
            return {
                ...state,
                [action.payload.name]: action.payload.state,
            };
        }

        if (resetSliceStateAction.match(action)) {
            return reducer({ ...state, [action.payload.name]: undefined }, action);
        }

        if (resetStateAction.match(action)) {
            return reducer(undefined, action);
        }

        return reducer(state, action);
    };
}
